import { Injectable } from '@angular/core';
import { ShelfTalkerCardContentViewModel } from '../../shared/shelf-talker-card-content-view-model';
import { Observable } from 'rxjs';
import { GlassHouseShelfTalkerCardData } from '../../../../../../../models/shelf-talkers/glass-house-shelf-talker-card-data';

@Injectable()
export class GlassHouseShelfTalkerPostCardContentViewModel extends ShelfTalkerCardContentViewModel {
  public readonly data$: Observable<GlassHouseShelfTalkerCardData | null>;
}
